export default class ProductPopupStore {
    private visible: boolean = false;
    private message: string = '';

    show(message: string) {
        this.message = message;
        this.visible = true;
    }

    hide() {
        this.visible = false;
        this.message = '';
    }

    get isVisible(): boolean {
        return this.visible;
    }
}